import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createWorkflowStatus,
  deleteWorkflowStatus,
  getWorkflowStatus,
  getWorkflowStatuses,
  getWorkflowStatusesMasterData,
  updateWorkflowStatus
} from '../../../api/workflow-statuses';

export const getWorkflowStatusesAsync = createAsyncThunk(
  'workflowStatuses/getWorkflowStatuses',
  getWorkflowStatuses
);

export const getWorkflowStatusesMasterDataAsync = createAsyncThunk(
  'workflowStatuses/getWorkflowStatusesMasterData',
  getWorkflowStatusesMasterData
);

export const getWorkflowStatusAsync = createAsyncThunk(
  'workflowStatuses/getWorkflowStatus',
  getWorkflowStatus
);

export const createWorkflowStatusAsync = createAsyncThunk(
  'workflowStatuses/createWorkflowStatus',
  createWorkflowStatus
);

export const updateWorkflowStatusAsync = createAsyncThunk(
  'workflowStatuses/updateWorkflowStatus',
  updateWorkflowStatus
);

export const deleteWorkflowStatusAsync = createAsyncThunk(
  'workflowStatuses/deleteWorkflowStatus',
  deleteWorkflowStatus
);

export interface WorkflowStatus {
  id: number;
  name: string;
}

interface WorkflowStatusState {
  data: WorkflowStatus[];
  masterData: WorkflowStatus[];
  count: number;
  selectedWorkflowStatus: WorkflowStatus | null;
}

const initialState: WorkflowStatusState = {
  data: [],
  masterData: [],
  count: 0,
  selectedWorkflowStatus: null
};

export default createSlice({
  name: 'workflowStatuses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWorkflowStatusesAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      getWorkflowStatusesMasterDataAsync.fulfilled,
      (state, action) => {
        state.masterData = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(getWorkflowStatusAsync.fulfilled, (state, action) => {
      state.selectedWorkflowStatus = action.payload;
    });
  }
});
